
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateMeetingParticipantDtoFormGroup() {
return new FormGroup({
    role: new FormControl<string | undefined>(''),
    attendanceStatus: new FormControl<string | undefined>(''),
})
;
}
      